import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';

export type AlertStatus = 'primary' | 'success' | 'danger' | 'warning' | 'info';

@Component({
  selector: 'ui-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent implements OnInit {
  @Input() alertText = '';
  @Input() alertTextTemplate!: TemplateRef<unknown>;
  @Input() alertStatus: AlertStatus = 'danger';
  @Input() mainIcon?: string; // unless explicitly set, will be set by alertStatus input
  @Input() sideIconIcon = '';
  @Input() sideIconText = '';
  @Input() showCloseBtn = false;
  @Input() fullWidth = false;
  @Input() fullWidthAlert = false;
  @Input() isSmsUnpaidProcess = false;
  @Output() handleCloseClick: EventEmitter<void> = new EventEmitter();
  @Output() handleSideIconClick: EventEmitter<void> = new EventEmitter();

  ngOnInit(): void {
    if (!this.mainIcon) {
      switch (this.alertStatus) {
        case 'primary': {
          this.mainIcon = 'get_app';
          break;
        }
        case 'success': {
          this.mainIcon = 'check_circle';
          break;
        }
        case 'danger': {
          this.mainIcon = 'warning';
          break;
        }
        case 'warning': {
          this.mainIcon = 'error';
          break;
        }
        case 'info': {
          this.mainIcon = 'info';
          break;
        }
        default: {
          this.mainIcon = 'warning';
          break;
        }
      }
    }
  }

  closeAlert(): void {
    if (this.showCloseBtn) {
      this.handleCloseClick.emit();
    }
  }

  onSideIconClick(event: Event): void {
    event.preventDefault();
    this.handleSideIconClick.emit();
  }
}
